import { useEffect, useRef } from 'react';

export default function usePreviousUnique(value: any) {
  const ref = useRef();

  useEffect(() => {
    if (ref.current !== value) ref.current = value;
  });

  return ref.current;
}
